import { createContext, useContext, useReducer, useCallback } from 'react'
import { useRouter } from 'next/router'
import { useDisclosure } from '@chakra-ui/react'
import { UserContext } from './user'
import axios from 'axios'
const initialState = {campaigns: null, campaign: null, selectedVariation: null, campaignIndex: 0 }
const AdsContext = createContext(initialState)

const AdsProvider = ({children}) => {
  const router = useRouter()
  const {state: userState, loginSuccess}  =useContext(UserContext)
  const [state, dispatch] = useReducer((state, action) => {
    switch(action.type) {
      case "SET_CAMPAIGN": 
        return {...state, campaign: action.value}
      case "SET_CAMPAIGNS":
        return {...state, campaigns: action.value}
      case "SET_SELECTED_VARIATION":
        return {...state, selectedVariation: action.value}
      case "SET_CAMPAIGN_INDEX":
        return {...state, campaignIndex: action.value}
        
      default:
        throw new Error()
    }
  }, initialState)

  const  onLoginSuccess = (res, save = false) => {
		loginSuccess(res, save, {type: "ads", data: state.campaign})
	}


  const newCampaign = async () => {
    const _campaign = { variations: [] }
		const { data } = await axios.post(`/api/campaigns/add`, { campaign: _campaign }, { headers: { 'Content-Type': 'application/json', authorization: userState.token } })
		const campaigns = [...state.campaigns, { id: data.campaignId, ..._campaign }]
		dispatch({ type: 'SET_CAMPAIGNS', value: campaigns })
		router.push(`/ads/${data.campaignId}`, null, { shallow: true })

		dispatch({ type: 'SET_CAMPAIGN_INDEX', value: campaigns.length - 1 })
		dispatch({ type: 'SET_CAMPAIGN', value:  {..._campaign, id: data.campaignId}})
	}

  const selectCampaign = (campaignsId) => {
		const i = state.campaigns.findIndex((q) => q.id === campaignsId)
		dispatch({ type: 'SET_CAMPAIGN_INDEX', value: i })
    dispatch({ type: 'SET_CAMPAIGN', value:  state.campaigns[i]})
		router.push(`/ads/${state.campaigns[i].id}`)
	}

    const saveCampaign = useCallback(async (campaignId, variations) => {
			await axios.put(`/api/campaigns/${campaignId}`, { variations }, { headers: { authorization: userState.token } })
	  }, [userState.token])

  const variationModalDisclosure = useDisclosure()
  const disclosures = {variationModalDisclosure}


  return <AdsContext.Provider value={{state, dispatch, newCampaign, selectCampaign, saveCampaign, onLoginSuccess, disclosures}}>{children}</AdsContext.Provider>
}

export { AdsProvider , AdsContext }